import {HelperFunctions} from "@/scripts/Common/HelperFunctions";
import moment from "moment";
import {DateFormats} from "@/scripts/Common/DateFormats";

const hasValidMinNumber = (value: number, minValue: number) => value >= minValue;

const hasValidMaxNumber = (value: number, maxValue: number) => value <= maxValue;

const hasValidDecimals = (value: number, maxDecimals: number) =>
    HelperFunctions.GetDecimalsCount(value.toString()) <= maxDecimals;

const isValidDate = (value: string) => moment(value, DateFormats.ISO8601_LONG, true).isValid();

export {
    hasValidMinNumber,
    hasValidMaxNumber,
    hasValidDecimals,
    isValidDate
}
